import axios from "axios";
import Vue from "vue";
import store from "@/store";
import setModule from "@/helpers/setModule.js";

const instance = createInstance();

function createInstance() {
  return axios.create({
    headers: {
      "Content-Type": "application/json",
    },
  });
}

instance.interceptors.request.use(
  (request) => {
    if (store.state.auth.token) {
      request.headers[
        "Authorization"
      ] = `Bearer ${store.state.auth.token}`;
    }


    let dataDefault = {
      language:
        store.state.system.language === "pt_BR"
          ? "pt"
          : store.state.system.language,
      clientId: store.state.system.clientId,
      system: store.state.system.system,
    };

    let module = request?.data?.module ? request.data.module : setModule(request, store.state.system.module);

    if (request.data instanceof FormData) {
      request.headers["Content-Type"] = "multipart/form-data";

      request.data.append("language", dataDefault.language);
      request.data.append("clientId", dataDefault.clientId);
      request.data.append("module", module);
      request.data.append("system", dataDefault.system);
    } else {
      request.data = {
        ...dataDefault,
        ...request.data,
        module,
      };
    }
    if (request.data?.noSaveStoreLastRequest) {
      return request;
    }
    
    return request;
  },
  (error) => {
    return Promise.reject(new Error(error))
  }
);

Vue.prototype.$http = instance;

export default {
  getInstance: () => instance,
};
